import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import axios from 'axios';
import 'core-js/modules/es.function.name.js';
import KwaiLog from '@kibt/weblogger/lib/log.hybrid';
import { useEffect } from 'react';
import yoda from '@kibt/bridge';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';

var service = axios.create({
  baseURL: '/',
  timeout: 30000
});
service.interceptors.request.use(function (config) {
  var requestConfig = config;
  requestConfig.startTime = new Date().getTime();
  return requestConfig;
});
service.interceptors.response.use(function (response) {
  // const endTime = new Date().getTime();
  var data = response.data;
  // const startTime = (config as RequestConfig).startTime;
  // const costTime = endTime - startTime;
  return data;
}, function (error) {
  error.response;
  return Promise.reject(error);
});

// 日志类型
var LogType;
(function (LogType) {
  // 曝光
  LogType["show"] = "SHOW";
  // 点击
  LogType["click"] = "CLICK";
  // PV
  LogType["pv"] = "PV";
  // 雷达事件
  LogType["custom"] = "CUSTOM";
})(LogType || (LogType = {}));
/**
 * 生成上报参数
 * @param data 上报数据
 * @returns PVOptions | ShowOptions | TaskOptions | CustomOptions
 */
var generateLogParams = function generateLogParams(data) {
  // PV曝光其他参数暂时不支持
  if (data.type === 'pv') {
    return {
      type: 'enter',
      page: data.name,
      params: data.value,
      eventId: data.eventId
    };
  }
  if (data.type === 'custom') {
    return {
      key: data.name,
      value: data.value,
      eventId: data.eventId
    };
  }
  // click 和 show 事件
  return {
    action: data.name,
    params: data.value,
    eventId: data.eventId
  };
};
var webLog;
var KrnWeblogger = /** @class */function () {
  function KrnWeblogger(params) {
    this.initWeblogger(params);
  }
  KrnWeblogger.prototype.initWeblogger = function (props) {
    props.autoPvConfig;
      var baseOptions = props.baseOptions,
      logConfig = props.logConfig;
    //logConfig
    var logInstance = new KwaiLog(logConfig, baseOptions).weblog;
    this.webLogger = logInstance;
    webLog = this;
    this.radar = this.webLogger.plugins.radar;
  };
  /**
   * 数据上报
   * @param data 上报数据
   * @param immediate 是否立即上报
   */
  KrnWeblogger.prototype.logCollect = function (data, immediate) {
    var type = data.type;
    // 不存在类型则不上报
    if (!type) {
      return;
    }
    var logParams = generateLogParams(data);
    var logType = LogType[type];
    if (immediate) {
      this.webLogger.sendImmediately(logType, logParams);
    } else {
      this.webLogger.collect(logType, logParams);
    }
  };
  KrnWeblogger.prototype.sendLog = function (data) {
    this.logCollect(data);
  };
  KrnWeblogger.prototype.immediateSendLog = function (data) {
    this.logCollect(data, true);
  };
  KrnWeblogger.prototype.sendAsyncPV = function (params) {
    var krnLogParams = params.pageMap({
      page: '',
      params: {}
    });
    var logParams = {
      name: krnLogParams.page,
      value: krnLogParams.params,
      type: 'pv'
    };
    this.logCollect(logParams, true);
  };
  KrnWeblogger.prototype.sendAsyncLog = function (compName, data) {
    this.logCollect(data, true);
  };
  KrnWeblogger.prototype.radarLog = function (data) {
    var _a, _b;
    var duration = data.duration,
      event_count = data.event_count;
    try {
      if ((_b = (_a = this.webLogger) === null || _a === void 0 ? void 0 : _a.plugins) === null || _b === void 0 ? void 0 : _b.radar) {
        this.webLogger.plugins.radar.event(data, {
          duration: duration,
          event_count: event_count
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  return KrnWeblogger;
}();

// @ts-ignore
var useAppShow = function useAppShow(fn, rootTag) {
  useEffect(function () {
    var listener = function listener(params) {
      var type = params === null || params === void 0 ? void 0 : params.type;
      if (type === 'appResume') {
        fn();
      }
    };
    yoda.event.addEventListener('resume', listener, function (_a) {
      _a.result;
    });
    return function cleanup() {
      // 移除事件
      yoda.event.removeEventListener('resume', listener, function (_a) {
        _a.result;
        return {};
      });
    };
  }, []);
};
var useAppHide = function useAppHide(fn, rootTag) {
  useEffect(function () {
    var listener = function listener(params) {
      var type = params === null || params === void 0 ? void 0 : params.type;
      if (type === 'appPause') {
        fn();
      }
    };
    yoda.event.addEventListener('pause', listener, function (_a) {
      _a.result;
    });
    return function cleanup() {
      // 移除事件
      yoda.event.removeEventListener('pause', listener, function (_a) {
        _a.result;
        return {};
      });
    };
  }, []);
};
var usePageShow = function usePageShow(fn, rootTag) {
  useEffect(function () {
    var listener = function listener(params) {
      var type = params === null || params === void 0 ? void 0 : params.type;
      if (type === 'pageResume') {
        fn();
      }
    };
    yoda.event.addEventListener('resume', listener, function (_a) {
      _a.result;
    });
    return function cleanup() {
      // 移除事件
      yoda.event.removeEventListener('resume', listener, function (_a) {
        _a.result;
        return {};
      });
    };
  }, []);
};
var usePageHide = function usePageHide(fn, rootTag) {
  useEffect(function () {
    var listener = function listener(params) {
      var type = params === null || params === void 0 ? void 0 : params.type;
      if (type === 'pagePause') {
        fn();
      }
    };
    yoda.event.addEventListener('pause', listener, function (_a) {
      _a.result;
    });
    return function cleanup() {
      // 移除事件
      yoda.event.removeEventListener('pause', listener, function (_a) {
        _a.result;
        return {};
      });
    };
  }, []);
};

var useScreenChange = function useScreenChange(showfn, hidefn) {};

var useResume = function useResume(listener, dependencies) {
  if (dependencies === void 0) {
    dependencies = [];
  }
  useEffect(function () {
    yoda === null || yoda === void 0 ? void 0 : yoda.ready().then(function () {
      var _a;
      // 监听webview到栈顶
      (_a = yoda === null || yoda === void 0 ? void 0 : yoda.event) === null || _a === void 0 ? void 0 : _a.addEventListener('resume', listener);
    });
    return function () {
      yoda.event.removeEventListener('resume', listener);
    };
  }, dependencies);
};

var rootTag;
var businessName;
var hostName;
var setGolbalConfig = function setGolbalConfig(config) {
  var _a, _b, _c;
  rootTag = (_a = config.rootTag) !== null && _a !== void 0 ? _a : rootTag;
  businessName = (_b = config.businessName) !== null && _b !== void 0 ? _b : businessName;
  hostName = (_c = config.hostName) !== null && _c !== void 0 ? _c : hostName;
  yoda.setConfig(config);
};

var PerfLogClass = /** @class */function () {
  function PerfLogClass() {
    this.time2 = 0;
    this.time3 = 0;
  }
  PerfLogClass.prototype.whiteScreen = function () {
    var _a, _b, _c;
    try {
      (_c = (_b = (_a = webLog.webLogger) === null || _a === void 0 ? void 0 : _a.plugins) === null || _b === void 0 ? void 0 : _b.radar) === null || _c === void 0 ? void 0 : _c.customStage('T1');
    } catch (error) {
      console.error(error);
    }
  };
  PerfLogClass.prototype.firstAPI = function () {
    var _a, _b, _c;
    if (this.time2 !== 0) return;
    this.time2 = new Date().valueOf();
    try {
      (_c = (_b = (_a = webLog.webLogger) === null || _a === void 0 ? void 0 : _a.plugins) === null || _b === void 0 ? void 0 : _b.radar) === null || _c === void 0 ? void 0 : _c.customStage('T2');
    } catch (error) {
      console.error(error);
    }
  };
  PerfLogClass.prototype.firstScreen = function () {
    var _a, _b, _c;
    if (this.time3 !== 0) return;
    this.time3 = new Date().valueOf();
    // 上报fmp
    try {
      (_c = (_b = (_a = webLog.webLogger) === null || _a === void 0 ? void 0 : _a.plugins) === null || _b === void 0 ? void 0 : _b.radar) === null || _c === void 0 ? void 0 : _c.fmp();
    } catch (error) {
      console.error(error);
    }
  };
  return PerfLogClass;
}();
var perfLog = new PerfLogClass();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var makeResult = function makeResult(data) {
  return {
    result: 1,
    message: data
  };
};
function getStorageItem(key) {
  var _a, _b, _c, _d;
  return __awaiter(this, void 0, void 0, function () {
    var result, result_1, error_1;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _e.trys.push([0, 2,, 3]);
          return [4 /*yield*/, (_b = (_a = yoda.component) === null || _a === void 0 ? void 0 : _a.getWebConfig) === null || _b === void 0 ? void 0 : _b.call(_a, {
            key: key
          })];
        case 1:
          result = _e.sent();
          if (result.result !== 1) {
            result_1 = (_d = (_c = window === null || window === void 0 ? void 0 : window.localStorage) === null || _c === void 0 ? void 0 : _c.getItem) === null || _d === void 0 ? void 0 : _d.call(_c, key);
            return [2 /*return*/, Promise.resolve(makeResult(result_1))];
          }
          return [2 /*return*/, result];
        case 2:
          error_1 = _e.sent();
          return [2 /*return*/, {
            result: 0,
            error: error_1
          }];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

function setStorageItem(key, value) {
  var _a, _b, _c, _d;
  return __awaiter(this, void 0, void 0, function () {
    var result, error_2;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _e.trys.push([0, 2,, 3]);
          return [4 /*yield*/, (_b = (_a = yoda.component) === null || _a === void 0 ? void 0 : _a.setWebConfig) === null || _b === void 0 ? void 0 : _b.call(_a, {
            value: value,
            key: key
          })];
        case 1:
          result = _e.sent();
          if (result.result !== 1) {
            (_d = (_c = window === null || window === void 0 ? void 0 : window.localStorage) === null || _c === void 0 ? void 0 : _c.setItem) === null || _d === void 0 ? void 0 : _d.call(_c, key, value);
            return [2 /*return*/, Promise.resolve({
              result: 1
            })];
          }
          return [2 /*return*/, result];
        case 2:
          error_2 = _e.sent();
          return [2 /*return*/, {
            result: 0,
            error: error_2
          }];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

function removeStorageItem(key) {
  var _a, _b, _c, _d;
  return __awaiter(this, void 0, void 0, function () {
    var result, error_3;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _e.trys.push([0, 2,, 3]);
          return [4 /*yield*/, (_b = (_a = yoda.component) === null || _a === void 0 ? void 0 : _a.setWebConfig) === null || _b === void 0 ? void 0 : _b.call(_a, {
            key: key,
            value: ''
          })];
        case 1:
          result = _e.sent();
          if (result.result !== 1) {
            (_d = (_c = window === null || window === void 0 ? void 0 : window.localStorage) === null || _c === void 0 ? void 0 : _c.removeItem) === null || _d === void 0 ? void 0 : _d.call(_c, key);
            return [2 /*return*/, Promise.resolve({
              result: 1
            })];
          }
          return [2 /*return*/, result];
        case 2:
          error_3 = _e.sent();
          return [2 /*return*/, {
            result: 0,
            error: error_3
          }];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

var localStorage = {
  getItem: function getItem(key) {
    return new Promise(function (resolve) {
      getStorageItem(key).then(function (res) {
        if (res.result === 1) {
          resolve(res.message);
        } else {
          return resolve(null);
        }
      });
    });
  },
  setItem: function setItem(key, value) {
    return setStorageItem(key, value);
  },
  removeItem: function removeItem(key) {
    return removeStorageItem(key);
  }
};

var platform = function getSys() {
  var ua = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent;
  var rules = [[/\(iPad;/, 'ipad'], [/\(iPhone;/, 'iphone'], [/ Android /, 'android'], [/ Mac OS X /, 'mac'], [/ Windows /, 'windows']];
  for (var i = 0; i < rules.length; i++) {
    var tmp = rules[i];
    var rule = tmp[0];
    var name_1 = tmp[1];
    var rRes = ua && rule.exec(ua);
    if (rRes) {
      return name_1;
    }
  }
  return '';
}();
var isAndroid = platform === 'android';
var isIOS = platform === 'iphone' || platform === 'ipad' || !isAndroid;
var convertStyles = function convertStyles(style) {
  return style;
};

var _initProps = {};
var setPageProps = function setPageProps(p) {
  if (p === void 0) {
    p = {};
  }
  _initProps = p;
};
var getPageProps = function getPageProps() {
  return _initProps;
};
var getUrlParam = function getUrlParam(p) {
  var _a;
  var url = new URL((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href);
  return _initProps[p] || (url === null || url === void 0 ? void 0 : url.searchParams.get(p)) || '';
};

var index = {
  request: service,
  logger: KrnWeblogger,
  //hooks 
  useResume: useResume,
  useAppShow: useAppShow,
  useAppHide: useAppHide,
  usePageShow: usePageShow,
  usePageHide: usePageHide,
  useScreenChange: useScreenChange,
  //api
  setGolbalConfig: setGolbalConfig,
  perfLog: perfLog,
  localStorage: localStorage,
  //utils
  isAndroid: isAndroid,
  isIOS: isIOS,
  convertStyles: convertStyles,
  //base
  setPageProps: setPageProps,
  getPageProps: getPageProps,
  getUrlParam: getUrlParam
};

export { convertStyles, index as default, getPageProps, getUrlParam, isAndroid, isIOS, localStorage, KrnWeblogger as logger, perfLog, service as request, setGolbalConfig, setPageProps, useAppHide, useAppShow, usePageHide, usePageShow, useResume, useScreenChange };
